<div *ngIf="dataConfig" class="container-block">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class"
            [backgroundClass]="class['frame-replied']" [backgroundConfig]="dataConfig" [isBlock]="false"
            [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>
    </div>
  </ng-container>

  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      
      <!-- Hiển thị -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class"
            [backgroundClass]="class['frame-replied']" [backgroundConfig]="dataConfig" [isBlock]="false"
            [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>

        </div>
      </li>
      
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="{{'cau_hinh_phan_tu' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}}</p>
            <input class="input-color"
              [style.background]="class['frame-replied__list--item']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-replied__list--item']['background-color']"
              (colorPickerClose)="updateClass()"  type="button"/>
          </div>

          <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
            [borderClass]="class['frame-replied__list--item']" [id_object]="objectChoosing._id">
          </app-borders-config>

          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>

      <!-- Cấu hình số lượng và xem thêm -->
      <li nz-submenu nzTitle="{{'cau_hinh_xem_them' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div>
          <div class="title mb-1 mt-0">{{'vi_tri_hien_thi' | translate}} </div>
          <nz-radio-group style="display:flex; flex-direction:column;"
            [(ngModel)]="config['position_display']"
            (ngModelChange)="updateStaticData()">
            <label nz-radio nzValue="top">{{'tren' | translate}}</label>
            <label nz-radio nzValue="bottom">{{'duoi' | translate}}</label>
          </nz-radio-group>
        </div>
        <div class="show-notification-text">
          <p class="title"> {{'so_luong_moi_lan_tai' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '60px' }" [nzStep]="1"
            [(ngModel)]="objectChoosing.staticdata.load_quantity"
            (nzBlur)="updateStaticData()"></nz-input-number>
        </div>

        <div class="show-notification-text">
          <p class="title"> {{'so_luong_ban_dau' | translate}} </p>
          <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '60px' }" [nzStep]="1"
            [(ngModel)]="objectChoosing.staticdata.init_quantity"
            (nzBlur)="updateStaticData()"></nz-input-number>
        </div>

        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="objectChoosing.staticdata.text_before_number"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="objectChoosing.staticdata.text_after_number"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>

        <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
          [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
          [textContentClass]="class['frame-replied__notification-text']"
          [textWrapperClass]="class['frame-replied__notification-text']">
        </app-text-format-config>

        <div class="font-adjusting">
          <div class="row-spacing">
            <span class="title"> {{'khoang_cach_dong' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
              [(ngModel)]="class['frame-replied__notification-text']['line-height']"
              (nzBlur)="updateClass()"></nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="0.1"
            [(ngModel)]="class['frame-replied__notification-text']['line-height']"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>

      </li>

      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <!-- Đổ bóng -->
        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['frame-replied']" [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu14" (nzOpenChange)="openHandler('menu14')">
        <app-choose-animations-config
          [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device" [class]="class"
          [config]="config" [staticdata]="objectChoosing.staticdata"
          [cursorClass]="class['frame-replied']"
          [effect_hover]="effect_hover" [customize]="customize"
          [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <div class="editor-header" *ngIf="isViewAll">
    <div class="return" (click)="isViewAll = !isViewAll" style="
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;
      ">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll" style="font-weight: 500;">
        {{currentViewAll.title | translate}}</span>
    </div>
  </div>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-replied__list--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-replied__list--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Bật đổ bóng -->
      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-replied__list--item']"
        [shadowConfig]="config['frame-replied__list--item']" [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="objectChoosing.staticdata" [id_object]="objectChoosing._id"
        [customize]="customize" [device]="device"></app-animations-config>
    </div>
  </div>
</div>
